export enum CanvasAlignment {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}
